module.exports = __webpack_public_path__ + "img/Icon_Floral_Fairground.72fd1215.png";